export default "__VITE_ASSET__d3cfa567__"